<template>
  <a-modal
    title="用户角色关联"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="24">
            <a-form-item label="关联角色">
              <a-select
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                mode="multiple"
                v-decorator="[
                  'role',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入角色名称"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in roleList">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import cloneDeep from 'lodash.clonedeep'

// 表单字段
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    return {
      form: this.$form.createForm(this),
      roleList: this.$Dictionaries.trade_user_roles
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      const user = cloneDeep(this.model)
      const role = user['role']
      user['role'] = this.decodeRoles(role)
      this.loadEditInfo(user)
    },
    decodeRoles (mask) {
      if (typeof mask !== 'number' || mask < 0) {
        throw new Error('Invalid mask value')
      }
      return Object.keys(this.$Dictionaries.trade_user_roles).map(Number)
        .filter(value => mask & value)
        .map(String)
    },
    loadEditInfo (data) {
      const { form } = this
      this.id = data.id
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['role'])
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
